import { useEffect } from 'react';

/**
 * Sets the document title when a component is mounted.
 * Optionally appends a shared suffix for consistent branding.
 *
 * @param {string} title
 * @param {Object} [options]
 * @param {boolean} [options.appendBrand=true]
 */
function usePageTitle(title, options) {
  const { appendBrand = true } = options || {};

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const base = appendBrand ? 'Slick Picks – ' : '';
    const fullTitle = title ? `${base}${title}` : 'Slick Picks';
    document.title = fullTitle;
  }, [title, appendBrand]);
}

export default usePageTitle;

